import { c as _c } from "react/compiler-runtime";
import { translateInline } from '@/globals/translate/translateInline';
import { WebAPIEffectiveDateInformation } from '@/globals/webApiTypes/elements/WebAPIEffectiveDateInformation';
import { textPillBox } from '@/sections/pill/Pill.css';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { textBlock } from '@/uiPrimitives/typography/text';
import { dateLongFormatter } from '@/globals/helpers/dateTimeFormatters';
const getEffectiveDateShortText = ({
  date,
  description
}: {
  date?: string;
  description?: string;
}) => {
  if (date == null && description == null) return null;
  if (date != null) {
    const effectiveDate = new Date(date);
    const formattedDate = dateLongFormatter.format(effectiveDate);
    return `${translateInline({
      en: 'Effective date',
      nl: 'Ingangsdatum'
    })}: ${formattedDate}`;
  }
  return `${translateInline({
    en: 'Effective date',
    nl: 'Ingangsdatum'
  })}: ${description}`;
};
const getEffectiveDateLongText = ({
  date,
  description
}: {
  date?: string;
  description?: string;
}) => {
  if (date == null && description == null) return null;
  if (date != null) {
    const currentDate = new Date();
    const effectiveDate = new Date(date);
    const formattedDate = dateLongFormatter.format(effectiveDate);
    if (currentDate < effectiveDate) {
      return `${translateInline({
        en: 'Effective date of this change in law:',
        nl: 'Dit wetsvoorstel gaat in op:'
      })} ${formattedDate}`;
    } else if (currentDate > effectiveDate) {
      return `${translateInline({
        en: 'This change in law took effect on:',
        nl: 'Deze wetswijziging is ingegaan op:'
      })} ${formattedDate}`;
    }
  }
  return `${translateInline({
    en: 'Effective date of this change in law:',
    nl: 'Ingangsdatum van dit wetsvoorstel:'
  })} ${description}`;
};
export const EffectiveDatePill = t0 => {
  const $ = _c(6);
  const {
    effectiveDateInformation
  } = t0;
  if (effectiveDateInformation == null) {
    return;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = textBlock({});
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== effectiveDateInformation) {
    t2 = getEffectiveDateLongText(effectiveDateInformation);
    $[1] = effectiveDateInformation;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = <div className={textPillBox}><span className={t1}>{t2}</span></div>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export const EffectiveDateText = t0 => {
  const $ = _c(6);
  const {
    effectiveDateInformation
  } = t0;
  if (effectiveDateInformation == null) {
    return;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(textBlock({
      capSize: "-1 | small",
      color: "positiveMuted",
      fontVariantNumeric: "lining-nums"
    }));
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== effectiveDateInformation) {
    t2 = getEffectiveDateShortText(effectiveDateInformation);
    $[1] = effectiveDateInformation;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = <span className={t1}>{t2}</span>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};